<template>
	<article ref="scrollBox" class="bus_list_wrap home CompareFlightIndex">
		<header class="pages_title">
			<div class="myHeader flexContainer">
				<div class="myHeaderL" @click="clearLast()"><i class="iconfont_new icon-Left"></i></div>
				<div class="myHeader textalignM">选择舱位</div>
				<div class="myHeaderR textalignR"></div>
			</div>
		</header>

		<section class="pages_content">
			<!-- 选择的去程 -->
			<div class="hangbanBox" style="margin-top: 0.25rem;">
				<div class="hangbanItem">
					<div class="card-item-tag-green">
						<span
							style="font-size: 20px !important;font-weight: bold;"
							v-if="info.airCompanyName == '中国国航' && (info.depCityName == '广州' || info.arrCityName == '广州') && (name == 'zsairport')"
						>
							送车票
						</span>
						<span
							style="font-size: 20px !important;font-weight: bold;"
							v-if="info.depCityName == '珠海' && info.arrAirportName == '大兴机场' && info.airCompanyName == '南方航空' && (name == 'zsairport')"
						>
							送车票
						</span>
					</div>
					<div class="flexContainer">
						<div class="flexItem3">
							<div class="flexContainer flight-info-wrap">
								<div class="flexItem1 textalignR">
									<div class="flight-time">{{ info.depTime }}</div>
									<div class="flight-deparrDate">{{ info.depDate }}</div>
									<div class="flight-airport">{{ info.depCityName + info.depAirportName + info.depTerminal }}</div>
								</div>
								<div class="icon-arrow"></div>
								<div class="flexItem1">
									<div class="flight-time">{{ info.arrTime }}</div>
									<div class="flight-deparrDate">{{ info.arrDate }}</div>
									<div class="flight-airport">{{ info.arrCityName + info.arrAirportName + info.arrTerminal }}</div>
								</div>
							</div>
						</div>
						<div class="textalignR">
							<div class="flightType" style="margin-top: 0.2rem;">去程</div>
							<!-- <div class="flight-number">
                <dfn>¥</dfn>
                <strong>{{ info.policys[0].priceDatas[0].price }}</strong>
                <dfn>起</dfn>
              </div>-->
						</div>
					</div>

					<div class="flexContainer">
						<div class="flexItem1">
							<div class="flight-plane">
								<img :src="info.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
								{{ info.airCompanyName }} {{ info.flightNo }}
							</div>
						</div>
						<div class="textalignR">
							<div class="flight-plane tag-advantage">
								<span v-if="info.isHasMeal == 1" style="margin-right:5px;">
									<i class="iconfont_new icon-canyin flight-planeIcon"></i>
									&nbsp;有餐食
								</span>
								<span v-if="info.stopNum == 0">
									<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
									&nbsp;直飞
								</span>
								<span v-else>
									<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
									&nbsp;经停{{ info.stopNum }}次
								</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 选择的返程 -->
				<div class="hangbanItem" v-if="selectedFlightList.length == 2">
					<div class="card-item-tag-green">
						<span
							style="font-size: 20px !important;font-weight: bold;"
							v-if="backInfo.airCompanyName == '中国国航' && (backInfo.depCityName == '广州' || backInfo.arrCityName == '广州') && (name == 'zsairport')"
						>
							送车票
						</span>
						<span
							style="font-size: 20px !important;font-weight: bold;"
							v-if="backInfo.depCityName == '珠海' && backInfo.arrAirportName == '大兴机场' && backInfo.airCompanyName == '南方航空' && (name == 'zsairport')"
						>
							送车票
						</span>
					</div>
					<div class="flexContainer">
						<div class="flexItem3">
							<div class="flexContainer flight-info-wrap">
								<div class="flexItem1 textalignR">
									<div class="flight-time">{{ backInfo.depTime }}</div>
									<div class="flight-deparrDate">{{ backInfo.depDate }}</div>
									<div class="flight-airport">{{ backInfo.depCityName + backInfo.depAirportName + backInfo.depTerminal }}</div>
								</div>
								<div class="icon-arrow"></div>
								<div class="flexItem1">
									<div class="flight-time">{{ backInfo.arrTime }}</div>
									<div class="flight-deparrDate">{{ backInfo.arrDate }}</div>
									<div class="flight-airport">{{ backInfo.arrCityName + backInfo.arrAirportName + backInfo.arrTerminal }}</div>
								</div>
							</div>
						</div>
						<div class="textalignR">
							<div class="flightType" style="margin-top: 0.2rem;">返程</div>
							<!-- <div class="flight-number">
                <dfn>¥</dfn>
                <strong>{{ backInfo.policys[0].priceDatas[0].price }}</strong>
                <dfn>起</dfn>
              </div>-->
						</div>
					</div>

					<div class="flexContainer">
						<div class="flexItem1">
							<div class="flight-plane">
								<img :src="backInfo.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
								{{ backInfo.airCompanyName }} {{ backInfo.flightNo }}
							</div>
						</div>
						<div class="textalignR">
							<div class="flight-plane tag-advantage">
								<span v-if="backInfo.isHasMeal == 1" style="margin-right:5px;">
									<i class="iconfont_new icon-canyin flight-planeIcon"></i>
									&nbsp;有餐食
								</span>
								<span v-if="backInfo.stopNum == 0">
									<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
									&nbsp;直飞
								</span>
								<span v-else>
									<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
									&nbsp;经停{{ backInfo.stopNum }}次
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 选择舱位 -->
			<div class="hangbanBox" style="margin-top:0.25rem;">
				<div class="hangbanItem" v-for="(policyItem, key) in dataList" :key="key" @click="check(key, policyItem.priceDatas[0].price)">
					<div class="flexContainer">
						<div style="margin-right:10px;padding-top: 0.2rem;">
							<i class="iconfont_new icon-duihao radioDiv" v-bind:class="{ radioDivCheck: policyItem.check }"></i>
						</div>
						<div class="flexItem3 flight-info-wrap marginT0">
							<i class="iconfont_new icon-zuowei1"></i>
							{{ policyItem.cabin[0].cabinCode }}舱&nbsp;&nbsp;
							<span class="freeTicket" v-if="policyItem.isFreeBusTicket && (name == 'zsairport')" style="font-size:0.3rem!important;">该航班舱位可获赠免费车票</span>
							<div class="needTips" style="margin-bottom: 0.2rem;">
								<span @click.stop="showChaRule(policyItem)">更改须知</span>
								<span @click.stop="showRefRule(policyItem)">退票须知</span>
								<span @click.stop="showLuggageRule(policyItem)">行李须知</span>
							</div>
						</div>
						<div class="flexItem1 textalignR">
							<div class="flight-number marginT0">
								<dfn>¥</dfn>
								<strong>{{ policyItem.priceDatas[0].price }}</strong>
							</div>
							<div class="ticket-right">剩余票：{{ policyItem.cabin[0].ticketCount == 'A' ? '>9' : policyItem.cabin[0].ticketCount }}</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<footer class="myFooter">
			<div class="flexContainer">
				<div class="flexItem1">
					<div class="myFooterPrice">
						<span class="myFooterPriceIcon">¥</span>
						{{ totalPrice }}
					</div>
				</div>
				<div class="myFooterBtnDiv">
					<div class="myFooterBtn" @click="goNextPage()" v-if="selectedFlightList.length == 2 || flightType == 1">下一步</div>
					<div class="myFooterBtn" @click="goPrePage()" v-if="selectedFlightList.length == 1 && flightType == 2">选择返程</div>
				</div>
			</div>
		</footer>
	</article>
</template>

<script>
import flightApi from '../request/flightApi';
import { mapState } from 'vuex';
import baseTool from '../utils/baseFunction';
export default {
	name: 'FlightNoDetail',
	computed: mapState({
		flightType: state => state.flight.flightType,
		psgType: state => state.flight.psgType,

		ifBackRefresh: state => state.flight.ifBackRefresh,

		selectedFlightList: state => state.flight.selectedFlightList,
		selectedPolicyList: state => state.flight.selectedPolicyList
	}),
	data() {
		return {
			name: '', // 商户标识
			totalPrice: 0,

			info: {}, // 去程的航班信息
			backInfo: {}, // 返程的航班信息

			key: 0,
			dataList: [],

			IsGoBack: ''
		};
	},
	components: {},
	activated: function() {
		if (this.$route.params.name && this.$route.params.name.length) {
			this.name = this.$route.params.name;
			this.IsGoBack = parseInt(this.$route.params.IsGoBack);
		}
		// console.log('FlightNoDetail-activated-ifBackRefresh',this.ifBackRefresh);

		if (this.flightType == 1 || this.IsGoBack == 0) {
			if (this.selectedFlightList != null && this.selectedFlightList != undefined && this.selectedPolicyList.length > 0) {
				this.setFlightStoreData({
					selectedPolicyList: []
				});
			}
		} else if (this.flightType == 2 && this.IsGoBack == 1) {
			if (this.selectedFlightList != null && this.selectedFlightList != undefined && this.selectedPolicyList.length > 1) {
				this.setFlightStoreData({
					selectedPolicyList: [this.selectedFlightList[0]]
				});
			}
		}

		// if (this.ifBackRefresh) {
		if (this.selectedFlightList.length == 1) {
			this.info = this.selectedFlightList[0];
			this.dataList = this.selectedFlightList[0].policys;
			this.key = 0;
		}
		if (this.selectedFlightList.length == 2) {
			this.info = this.selectedFlightList[0];
			this.backInfo = this.selectedFlightList[1];
			this.dataList = this.selectedFlightList[1].policys;
			this.key = 1;
		}
		this.cleanCheck();
		// }
	},
	created() {
		console.log('FlightNoDetail-Createed');
	},
	mounted() {
		console.log('FlightNoDetail-Mounted');
	},
	methods: {
		setFlightStoreData(updateObj) {
			this.$store.commit('flight/setFlightQueryCondition', updateObj);
		},
		//选中：
		check(key, price) {
			// console.log(key);
			for (let i = 0; i < this.dataList.length; i++) {
				this.dataList[i].check = false;
				if (key == i) {
					this.dataList[i].check = true;
					this.totalPrice = price; //赋值给底部总价
					this.$forceUpdate();
				}
			}
		},
		cleanCheck() {
			//初始化时：默认不选中某一个
			for (let i = 0; i < this.dataList.length; i++) {
				this.dataList[i].check = false;
			}
			this.totalPrice = 0;
		},
		showChaRule(policyItem) {
			var that = this;
			flightApi
				.getStipulates(
					this.selectedFlightList[this.key].flightProductType, //
					this.flightType, //
					policyItem.cabin[0].cabinCode, //
					this.psgType,
					this.selectedFlightList[this.key].depAirportCode,
					this.selectedFlightList[this.key].arrAirportCode,
					this.selectedFlightList[this.key].depDate, //
					this.selectedFlightList[this.key].flightNo //
				)
				.then(sucRes => {
					if (sucRes.success) {
						let text = {};
						text.chaRule = sucRes.data.chaRule;
						text.refRule = sucRes.data.refRule;
						text.luggage = sucRes.data.luggage;

						that.$Modal.warning({
							title: '改签规则',
							content: '改签规则：' + (text.chaRule == null ? '特价票不可改签' : text.chaRule.content)
						});
					}
				});
		},
		showRefRule(policyItem) {
			var that = this;
			flightApi
				.getStipulates(
					this.selectedFlightList[this.key].flightProductType,
					this.flightType,
					policyItem.cabin[0].cabinCode,
					this.psgType,
					this.selectedFlightList[this.key].depAirportCode,
					this.selectedFlightList[this.key].arrAirportCode,
					this.selectedFlightList[this.key].depDate,
					this.selectedFlightList[this.key].flightNo
				)
				.then(sucRes => {
					if (sucRes.success) {
						let text = {};
						text.chaRule = sucRes.data.chaRule;
						text.refRule = sucRes.data.refRule;
						text.luggage = sucRes.data.luggage;
						this.$Modal.warning({
							title: '退票须知',
							content: '退票规则：' + (text.refRule == null ? '特价票不可退票' : text.refRule.content)
						});
					}
				});
		},
		showLuggageRule(policyItem) {
			flightApi
				.getStipulates(
					this.selectedFlightList[this.key].flightProductType,
					this.flightType,
					policyItem.cabin[0].cabinCode,
					this.psgType,
					this.selectedFlightList[this.key].depAirportCode,
					this.selectedFlightList[this.key].arrAirportCode,
					this.selectedFlightList[this.key].depDate,
					this.selectedFlightList[this.key].flightNo
				)
				.then(sucRes => {
					if (sucRes.success) {
						let text = {};
						text.luggage = sucRes.data.luggage;
						this.$Modal.warning({
							title: '行李规定',
							content: '行李规定：' + text.luggage
						});
					}
				});
		},

		clearLast() {
			let selectedFlightList = [...this.selectedFlightList];
			selectedFlightList.pop();

			this.$store.commit('flight/setFlightQueryCondition', {
				selectedFlightList: selectedFlightList,
				ifBackRefresh: false //后退不刷新
			});

			this.$router.go(-1);
		},

		//选择返程
		goPrePage() {
			let checkRecord = this.dataList.filter(item => item.check === true);
			console.log('checkRecord->',checkRecord);
			if (checkRecord.length == 0) {
				this.$Modal.error({
					title: '提示',
					content: '请选择舱位！'
				});
				return false;
			} else {
				let selectedPolicyList = [...this.selectedPolicyList];
				selectedPolicyList.push(checkRecord[0]);

				this.$store.commit('flight/setFlightQueryCondition', {
					selectedPolicyList: selectedPolicyList,
					ifBackRefresh: true //后退刷新
				});

				let that = this;
				this.$router.push({
					name: 'FlightNoList',
					params: {
						name: that.name,
						IsGoBack: that.IsGoBack + 1
					}
				});
			}
		},

		//跳转到下一页：
		goNextPage() {
			let checkRecord = this.dataList.filter(item => item.check === true);
			console.log('checkRecord->',checkRecord);
			if (checkRecord.length == 0) {
				this.$Modal.error({
					title: '提示',
					content: '请选择舱位！'
				});
				return false;
			} else {
				let selectedPolicyList = [...this.selectedPolicyList];
				selectedPolicyList.push(checkRecord[0]);
				console.log('selectedPolicyList->',selectedPolicyList);

				this.$store.commit('flight/setFlightQueryCondition', {
					selectedPolicyList: selectedPolicyList,
					ifBackRefresh: true //后退刷新
				});

				this.$router.push({
					name: 'order-confirm',
					params: {
						name: this.name,
						IsGoBack: this.IsGoBack
					}
				});
			}
		}
	}
};
</script>

<style scoped lang="less">
@import '../style/home.less';

.pages_title {
	background-color: transparent;
	padding: 0;
	color: #fff;
	border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightNoDetail.vue